import type { EntityType } from 'types/entityType';

import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('singleSelectPanel');

    return {
        CHOOSE_ONE: (entityType?: EntityType) =>
            entityType ? t('chooseEntity', { entityType }) : t('chooseOne')
    };
};

export default useTranslation;
